/**

 * @作者 王

 * @创建于 2021/5/17 15:45

 */
import axios from "axios";
import router from "../router";
import { message } from "../plugins/resetMessage";
import md5 from "js-md5";
import { Base64 } from "js-base64";
import store from "../store";
// 默认超时设置
axios.defaults.timeout = 50000;

//http request 拦截器
axios.interceptors.request.use(
    (config) => {
        // 设置参数格式
        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/json";
        }
        if (store.state.token) config.headers["x-token"] = store.state.token;
        if (store.state.sessionID)
            config.headers["x-sessionId"] = store.state.sessionID;
        // 鉴权参数设置
        if (config.method === "get") {
            //get请求下 参数在params中，其他请求在data中
            config.params = config.params || {};
            let json = JSON.parse(JSON.stringify(config.params));
            //一些参数处理
        } else {
            config.data = config.data || {};
            try {
                config.headers["x-path"] = router.app._route.fullPath;
            } catch (e) {}
            let str = `${store.state.sessionID}_${config.url.replace(
                window.webConfig.baseApiPath,
                ""
            )}_${JSON.stringify(config.data)}`;
            config.headers["x-xsrf"] = Base64.encode(md5(str.toLowerCase())).replace(
                /=/g,
                ""
            );
            //一些参数处理
        }
        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);
//http response 拦截器
axios.interceptors.response.use(
    (response) => {
        //一些统一code的返回处理
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function fetch(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params,
            })
            .then((response) => {
                if (response.data.code === 200) {
                    //返回成功处理  这里传的啥 后续调用的时候 res就是啥
                    resolve(response.data.data); //我们后台所有数据都是放在返回的data里所以这里统一处理了
                } else {
                    //错误处理
                    reject(response.data.msg);
                    message.error(response.data.msg);
                }
            })
            .catch((err) => {
                reject(err);
                let message2 = "请求失败！请检查网络";
                //错误返回
                if (err.response) message2 = err.response.data.message;
                message.error(message2);
            });
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */

export function post(url, data = {}, config) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config).then(
            (response) => {
                if (response.data.code === 200) {
                    resolve(response.data.data);
                } else {
                    reject(response.data.msg);
                    if (response.data.code === 40101 || response.data.code === 401) {
                        router.replace('/login');
                    }
                    console.log(response, "response");
                    message.error(response.data.msg);
                }
            },
            (err) => {
                reject(err);
                let message2 = "请求失败！请检查网络";
                if (err.response) message2 = err.response.data.msg;
                message.error(message2);
            }
        );
    });
}
/**
 *
 *执法分类
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */
export function postzf(url, data = {}, config) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config).then(
            (response) => {
                console.log(response.data.statusCode, "1111");
                if (response.data.statusCode === "200") {
                    resolve(response.data.resMap);
                } else {
                    reject(response.data.statusMsg);
                    if (response.data.statusCode === 40101 || response.data.code === 401) {
                        router.replace('/login');
                    }
                    message.error(response.data.statusMsg);
                }
            },
            (err) => {
                reject(err);
                let message2 = "请求失败！请检查网络";
                if (err.response) message2 = err.response.data.statusMsg;
                message.error(message2);
            }
        );
    });
}
/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data).then(
            (response) => {
                if (response.data.code === 200) {
                    resolve(response.data.data);
                } else {
                    message.error(response.data.msg);
                }
            },
            (err) => {
                reject(err);
                let message2 = "请求失败！请检查网络";
                if (err.response) message2 = err.response.data.message;
                message.error(message2);
            }
        );
    });
}

export function downloadPost(url, data = {}, config) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config).then(
            (response) => {
                if (response.data.code === 200) {
                    resolve(response.data.data);
                    const blob = new Blob([response.data.data.downLoadPath]);
                    let fileName = response.data.data.downLoadPath;
                    // let fileName = response.data.data.downLoadPath.substring(51);
                    // if (response.data.data.downLoadPath.indexOf('image') > -1) {
                    //     console.log(response.data.data.downLoadPath.indexOf('image'),'11')
                    //     fileName = fileName + '.jpg';
                    // }

                    if ("download" in document.createElement("a")) {
                        // 非IE下载
                        const elink = document.createElement("a");
                        elink.download = fileName;
                        elink.style.display = "none";
                        // elink.href = URL.createObjectURL(blob);
                        elink.href = response.data.data.downLoadPath;
                        document.body.appendChild(elink);
                        elink.click();
                        console.log(elink, "elink");
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                        resolve();
                    } else {
                        // IE10+下载
                        navigator.msSaveBlob(blob, fileName);
                        resolve();
                    }
                } else {
                    reject(response.data.msg);
                    if (response.data.code === 40101 || response.data.code === 401) {
                        router.replace('/login');
                    }
                    message.error(response.data.msg);
                }
            },
            (err) => {
                reject(err);
                let message2 = "请求失败！请检查网络";
                if (err.response) message2 = err.response.data.msg;
                message.error(message2);
            }
        );
        // axios({ // 用axios发送post请求
        //     method: 'post',
        //     url: url, // 请求地址
        //     data: data, // 参数
        //     responseType: 'blob' // 表明返回服务器返回的数据类型
        // })
        //     .then(response => {
        //         const blob = new Blob([response.data]);
        //         let fileName = 'download';
        //         if (response.headers['content-type'].indexOf('image') > -1) {
        //             fileName = fileName + '.jpg';
        //         }
        //         if ('download' in document.createElement('a')) { // 非IE下载
        //             const elink = document.createElement('a');
        //             elink.download = fileName;
        //             elink.style.display = 'none';
        //             elink.href = URL.createObjectURL(blob);
        //             document.body.appendChild(elink);
        //             elink.click();
        //             URL.revokeObjectURL(elink.href);// 释放URL 对象
        //             document.body.removeChild(elink);
        //             resolve()
        //         } else { // IE10+下载
        //             navigator.msSaveBlob(blob, fileName);
        //             resolve()
        //         }
        //     }).catch(() => {
        //         reject()
        //     })
    });
}

export function download(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios({
            // 用axios发送post请求
            method: "post",
            url: url, // 请求地址
            data: data, // 参数
            responseType: "blob", // 表明返回服务器返回的数据类型
        })
            .then((response) => {
                const blob = new Blob([response.data], {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                // Content-Disposition: attachment; filename="filename.xls"
                let fileName = "download";
                if (response.headers["content-type"].indexOf("image") > -1) {
                    fileName = fileName + ".jpg";
                }
                if ("download" in document.createElement("a")) {
                    // 非IE下载
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                    resolve();
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName);
                    resolve();
                }
            })
            .catch(() => {
                reject();
            });
    });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data).then(
            (response) => {
                if (response.data.code === 200) {
                    resolve(response.data.data);
                } else {
                    message.error(response.data.msg);
                }
            },
            (err) => {
                reject(err);
                let message2 = "请求失败！请检查网络";
                if (err.response) message2 = err.response.data.message;
                message.error(message2);
            }
        );
    });
}

export function del(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.delete(url, data).then(
            (response) => {
                if (response.data.code === 200) {
                    resolve(response.data.data);
                } else {
                    message.error(response.data.msg);
                }
            },
            (err) => {
                reject(err);
                let message2 = "请求失败！请检查网络";
                if (err.response) message2 = err.response.data.message;
                message.error(message2);
            }
        );
    });
}
